import { render, staticRenderFns } from "./termschart.vue?vue&type=template&id=62f1ad8f&scoped=true&"
import script from "./termschart.vue?vue&type=script&lang=js&"
export * from "./termschart.vue?vue&type=script&lang=js&"
import style0 from "./termschart.vue?vue&type=style&index=0&id=62f1ad8f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62f1ad8f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\zy_frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('62f1ad8f')) {
      api.createRecord('62f1ad8f', component.options)
    } else {
      api.reload('62f1ad8f', component.options)
    }
    module.hot.accept("./termschart.vue?vue&type=template&id=62f1ad8f&scoped=true&", function () {
      api.rerender('62f1ad8f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/physical/termschart.vue"
export default component.exports